// Angular modules
import { Directive }        from '@angular/core';
import { ViewContainerRef } from '@angular/core';

@Directive({
  selector : '[appFilterEngine]'
})
export class FilterEngineDirective
{
  constructor(public viewContainerRef : ViewContainerRef) {}
}
